import { render } from "./MetricDelete.vue?vue&type=template&id=c03ea032&ts=true"
import script from "./MetricDelete.vue?vue&type=script&lang=ts"
export * from "./MetricDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__